import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@planuze/ui';
import { MonitorIcon, MoonIcon, SunIcon } from 'lucide-react';
import type { JSX } from 'react';
import { useCommonContent } from '../content/sections/common.js';
import { type ThemePreference, useTheme } from './theme-provider.js';

/* Alterna o tema do backoffice (ADR-0699). Botão ícone (Sol/Lua conforme o tema resolvido) +
   menu com as 3 preferências, espelhando o switcher do produto. */
const OPTIONS: ReadonlyArray<{ value: ThemePreference; icon: typeof SunIcon }> = [
  { value: 'light', icon: SunIcon },
  { value: 'dark', icon: MoonIcon },
  { value: 'system', icon: MonitorIcon },
];

export function ThemeToggle(): JSX.Element {
  const { preference, resolved, setPreference } = useTheme();
  const copy = useCommonContent().themeToggle;
  const labelFor: Readonly<Record<ThemePreference, string>> = {
    light: copy.light,
    dark: copy.dark,
    system: copy.system,
  };
  const TriggerIcon = resolved === 'dark' ? MoonIcon : SunIcon;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={copy.ariaLabel}>
          <TriggerIcon className="size-4" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {OPTIONS.map(({ value, icon: Icon }) => (
          <DropdownMenuItem
            key={value}
            onSelect={() => setPreference(value)}
            className={preference === value ? 'text-foreground' : 'text-muted-foreground'}
          >
            <Icon className="size-3.5" aria-hidden="true" />
            {labelFor[value]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
